<template>
	<div>
		<header>
			<div style="display: block;">
				<div class="cu-custom" style="height: 45px;">
					<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
						<div class="content text-gold" style="top: 0px;">
							<div>{{$t('zijinminxi')}}</div>
						</div>
						<div class="action" @click="changego">
							<text class="cuIcon-back" style="width: 50px;">
								<span></span>
							</text>
						</div>
					</div>
				</div>
			</div>
		</header>
		<!-- 顶部导航按钮 -->
		<div class="tab-buttons">
			<div @click="switchTab('recharge')" :class="{active: activeTab === 'recharge'}">{{$t('cunru')}}/{{$t('zhuanchu')}}</div>
			<div @click="switchTab('investment')" :class="{active: activeTab === 'investment'}">{{$t('touzi')}}</div>
			<div @click="switchTab('profit')" :class="{active: activeTab === 'profit'}">{{$t('shouyi')}}</div>
		</div>

		<div v-if="activeTab === 'recharge'">
			<div class="cu-list menu-avatar" style="padding: 0px 5px;" v-for="(item, index) in list" :key="index">
				<div class="cu-item bg-gradual-black radius" style="margin-top: 5px; border-radius: 12px;"
					v-if="item.type === '0' || item.type === '1' || item.type === '4'">
					<div class="cu-avatar round lg margin-xs "
						:class="{   'bg-gradual-orange': item.type === '0', 'bg-gradual-purple': item.type === '1','bg-gradual-red': item.type === '4'  }"
						style=" white-space: unset; width: 80px; border-radius: 15px; left: 5px;">
						<text class="avatar-text">
							<span>{{ getLlName(item) }}</span>
						</text>
					</div>
					<div class="content" style="left: 100px;">
						<div class=" text-sm flex">
							<div class="cu-tag radius light text-xs margin-left bg-green"
								style="min-width: 50px;margin-left: 60%;">
								{{$t('chenggong')}}
							</div>
						</div>
						<div class="text-yellow" style="font-size: 13px;margin-left:-50%;margin-top: -12%;">
							{{ formatTime(item.createtime) }}
						</div>
						<div class="text-yellow"
							style="font-size: 12px;margin-left: -40%;margin-top: 5%;color: #0081ff;">
							Serial
							No:{{ item.mark }}
						</div>
						<div class="text-sm flex"></div>
					</div>
					<div class="action" style="width: 80px;">
						<div class="cu-tag radius bg-red " style="min-width: 65px;">{{ item.quantity }}</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="activeTab === 'investment'">
			<div class="cu-list menu-avatar" style="padding: 0px 5px;" v-for="(item, index) in list" :key="index">
				<div class="cu-item bg-gradual-black radius" style="margin-top: 5px; border-radius: 12px;"
					v-if="item.type === '2' ">
					<div class="cu-avatar round lg margin-xs "
						:class="{  'bg-gradual-black': item.type === '4','bg-gradual-blue': item.type === '2',  'bg-gradual-orange': item.type === '0', 'bg-gradual-yellow': item.type === '3',   'bg-gradual-purple': item.type === '1' }"
						style=" white-space: unset; width: 80px; border-radius: 15px; left: 5px;">
						<text class="avatar-text">
							<span>{{ getLevelName(item.type) }}</span>
						</text>
					</div>
					<div class="content" style="left: 100px;">
						<div class=" text-sm flex">
							<div class="text-cut text-cyan" style="font-size: 12px;">
								{{ item.name || null }}-{{ item.issue || null }} {{$t('lunm')}}
							</div>
						</div>
						<div class=" text-sm flex">
							<div class="text-cut text-cyan" style="font-size: 12px;">
								{{ `${getnamen(item.play_method) || ''}/${item.odds || ''}` }}
							</div>
							<div class="cu-tag radius light text-xs margin-left bg-green" style="min-width: 50px;">
								{{$t('chenggong')}}
							</div>
						</div>
						<div class="text-yellow" style="font-size: 13px;margin-left:-50%">
							{{ formatTime(item.createtime) }}
						</div>
						<div class="text-sm flex"></div>
					</div>
					<div class="action" style="width: 80px;">
						<div class="cu-tag radius bg-red " style="min-width: 65px;">{{ item.quantity }}</div>
					</div>
				</div>

			</div>
		</div>

		<div v-if="activeTab === 'profit'">
			<div class="cu-list menu-avatar" style="padding: 0px 5px;" v-for="(item, index) in lists" :key="index">
				<div class="cu-item bg-gradual-black radius" style="margin-top: 5px; border-radius: 12px;"
					v-if="item.type === '3' ">
					<div class="cu-avatar round lg margin-xs "
						:class="{  'bg-gradual-black': item.type === '4','bg-gradual-blue': item.type === '2',  'bg-gradual-orange': item.type === '0', 'bg-gradual-yellow': item.type === '3',   'bg-gradual-purple': item.type === '1' }"
						style=" white-space: unset; width: 80px; border-radius: 15px; left: 5px;">
						<text class="avatar-text">
							<span>{{ getLevelName(item.type) }}</span>
						</text>
					</div>
					<div class="content" style="left: 100px;">
						<div class=" text-sm flex">
							<div class="text-cut text-cyan" style="font-size: 12px;">
								{{ item.name || null }}-{{ item.issue || null }} {{$t('lunm')}}
							</div>
						</div>
						<div class=" text-sm flex">
							<div class="text-cut text-cyan" style="font-size: 12px;">
								{{ `${getnamen(item.play_method) || ''}/${item.odds || ''}` }}
							</div>
							<div class="cu-tag radius light text-xs margin-left bg-green" style="min-width: 50px;">
								{{$t('chenggong')}}
							</div>
						</div>
						<div class="text-yellow" style="font-size: 13px;margin-left:-50%">
							{{ formatTime(item.createtime) }}
						</div>
						<div class="text-sm flex"></div>
					</div>
					<div class="action" style="width: 80px;">
						<div class="cu-tag radius bg-red " style="min-width: 65px;">{{ item.quantity }}</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import userApi from "@/api/user";
	import time from "@/utils/time";
	export default {
		name: "BetRecord",
		components: {},
		data() {
			return {
				show: false,
				list: [],
				loading: false,
				finished: false,
				refreshing: false,
				statueList: ["全部", "未盈利", "已盈利", "已受理", "未受理", "已取消"],
				statueActive: 0,
				minDate: new Date(2018, 0, 1),
				maxDate: new Date(),
				currentDate: new Date(),
				begin_date: "",
				end_date: "",
				showTime: false,
				lists: [],
				activeTab: 'recharge', // 默认显示充值板块
			};
		},
		methods: {
			switchTab(tab) {
				this.activeTab = tab;
			},

			getLlName(item) {
				if (item.type === '0') {
					return item.status === '2' ? this.$t('chongzzi') : this.$t('cunru');
				} else if (item.type === '1') {
					return item.status === '2' ? this.$t('shiabais') : this.$t('zhuanchu');
				} else if (item.type === '4') {
					return this.$t('caijinj');
				}
				return '';
			},
			getLevelName(type) {
				let names = [
					this.$t('cunru'),
					this.$t('zhuanchu'),
					this.$t('touzi'),
					this.$t('shouyi'),
					this.$t('zhengsong'),
				]
				return names[type] || ''
			},

			getnamen(playMethod) {
				const map = {
					'涨': '涨',
					'大涨': '大涨',
					'小涨': '小涨',
					'跌': '跌',
					'大跌': '大跌',
					'小跌': '小跌',
				}
				return map[playMethod] || playMethod
			},
			getPlanKey(planName) {
				const map = {
					'VVIP': 'chaoguibin',
					'基础理财': 'jichu',
					'资深理财': 'putong',
					'专家理财': 'guibin',
					'大师理财': 'zhuanye'
				}
				return map[planName] || planName
			},
			formatTime(timestamp) {
				const date = new Date(timestamp * 1000)
				const month = (date.getMonth() + 1).toString().padStart(2, '0')
				const day = date.getDate().toString().padStart(2, '0')
				const year = date.getFullYear()
				const hours = date.getHours().toString().padStart(2, '0')
				const minutes = date.getMinutes().toString().padStart(2, '0')
				const seconds = date.getSeconds().toString().padStart(2, '0')
				return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`
			},
			timeStr(items) {
				return time.formatDatethree(items * 1000);
			},
			Reset() {
				this.statueActive = 0;
				this.begin_date = "";
				this.end_date = "";
			},
			BtnOk() {
				this.show = false;
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					duration: 0,
					forbidClick: true,
				});
				userApi
					.quantityLogList(
						this.begin_date ? this.begin_date : this.formatDate(new Date()),
						this.end_date ? this.end_date : this.formatDate(new Date())
					)
					.then((data) => {
						// console.log(data, 4332)
						if (data.data.length) {
							this.list = data.data;
						} else {
							this.list = []
							this.$toast(this.$t('Tips.zanwu'));
						}
					});
				this.loading = false;
				this.finished = true;
				this.$toast.clear();
			},
			cca() {
				this.show = false;
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					duration: 0,
					forbidClick: true,
				});
				userApi
					.quantityLogL(
						this.begin_date ? this.begin_date : this.formatDate(new Date()),
						this.end_date ? this.end_date : this.formatDate(new Date())
					)
					.then((data) => {
						// console.log(data, 4332)
						if (data.data.length) {
							this.lists = data.data;
						} else {
							this.lists = []
							this.$toast(this.$t('Tips.zanwu'));
						}
					});
				this.loading = false;
				this.finished = true;
				this.$toast.clear();
			},
			formatDate(date) {
				let yy = date.getFullYear();
				let mm = date.getMonth() + 1;
				mm = mm.toString();
				let dd = date.getDate().toString();
				return yy + "-" + mm.padStart(2, 0) + "-" + dd.padStart(2, 0);
			},
			changeTime(value) {
				console.log(this.formatDate(value));
				if (this.showTimeType == 0) {
					this.begin_date = this.formatDate(value);
				} else {
					this.end_date = this.formatDate(value);
				}
			},
			onRefresh() {
				this.refreshing = false;
				this.finished = false;
				this.loading = true;
				this.BtnOk();
				this.cca();
			},
			changego() {
				this.$router.go(-1);
			},
			onLoad() {
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
					this.BtnOk();
				}
			},
			changeDetail(item) {
				// 传详情iD
				this.$router.push({
					path: "/betDetail",
					query: {
						item: JSON.stringify(item)
					},
				});
			},
		},
		mounted() {
			this.onRefresh();
		},
	};
</script>

<style>
	.tab-container {
		display: flex;
		justify-content: center;
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.tab-buttons {
		margin-left: 30px;
		margin-top: 20px;
		display: flex;
		gap: 20px;
		margin-buttom: 20px;
	}

	.tab-buttons div {
		width: 28%;
		padding: 12px 24px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		border-radius: 6px;
		cursor: pointer;
		font-size: 12px;
		font-weight: 500;
		color: #fff;
		transition: all 0.3s ease;
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
	}

	.tab-buttons div:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
	}

	.tab-buttons div.active {
		background: #1890ff;
		color: white;
		box-shadow: 0 4px 8px rgba(24, 144, 255, 0.3);
	}

	.bg-gradual-red {
		background-image: linear-gradient(45deg, #f43f3b, #ec008c);
		color: #fff;
	}

	.bg-gradual-purple {
		background-image: linear-gradient(45deg, #9000ff, #5e00ff);
		color: #fff;
	}

	.bg-gradual-yellow {
		background-image: linear-gradient(45deg, #e6e813, #dd8139);
		color: #fff;
	}

	.bg-gradual-orange {
		background-image: linear-gradient(45deg, #ff9700, #ed1c24);
		color: #fff;
	}

	.bg-gradual-blue {
		background-image: linear-gradient(45deg, #0081ff, #1cbbb4);
		color: #fff;
	}

	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}


	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}



	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.cu-list.menu-avatar>.cu-item {
		position: relative;
		display: flex;
		padding-right: 5px;
		height: 80px;
		background-color: #fff;
		justify-content: flex-end;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.cu-list.menu-avatar>.cu-item>.cu-avatar {
		position: absolute;
		left: 17px;
	}

	.cu-avatar.lg {
		width: 55px;
		height: 55px;
		font-size: 2em;
	}

	.bg-gradual-yellow {
		background-image: linear-gradient(45deg, #e6e813, #dd8139);
		color: #fff;
	}

	.margin-xs {
		margin: 5px;
	}

	.cu-avatar {
		font-variant: small-caps;
		margin: 0;
		padding: 0;
		display: inline-flex;
		text-align: center;
		justify-content: center;
		align-items: center;
		background-color: #ccc;
		color: #fff;
		white-space: nowrap;
		position: relative;
		width: 36px;
		height: 36px;
		background-size: cover;
		background-position: 50%;
		vertical-align: middle;
		font-size: 1.5em;
	}

	.cu-avatar .avatar-text {
		font-size: .4em;
	}

	.cu-list.menu-avatar>.cu-item .content {
		position: absolute;
		left: 83px;
		width: calc(100% - 55px - 34px - 68px - 11px);
		line-height: 1.6em;
	}

	.cu-list.menu-avatar>.cu-item .content>div:first-child {
		font-size: 17px;
		display: flex;
		align-items: center;
	}

	.flex {
		display: flex;
	}

	.text-yellow,
	.line-yellow,
	.lines-yellow {
		color: #fbbd08;
	}

	.cu-list.menu-avatar>.cu-item .flex .text-cut {
		max-width: 292px;
	}

	.text-cyan,
	.line-cyan,
	.lines-cyan {
		color: #1cbbb4;
	}

	.text-cut {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.bg-green.light {
		color: #39b54a;
		background-color: #d7f0db;
	}

	.text-xs {
		font-size: 11px;
	}

	.margin-left {
		margin-left: 17px;
	}

	.cu-tag {
		font-size: 13px;
		vertical-align: middle;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0px 9px;
		height: 27px;
		font-family: Helvetica Neue, Helvetica, sans-serif;
		white-space: nowrap;
	}

	.radius {
		border-radius: 3px;
	}

	.cu-list.menu-avatar>.cu-item .action {
		width: 57px;
		text-align: center;
	}

	.bg-red {
		background-color: #e54d42;
		color: #fff;
	}

	.cu-list.menu-avatar>.cu-item:after,
	.cu-list.menu>.cu-item:after {
		position: absolute;
		top: 0;
		left: 0;
		box-sizing: border-box;
		width: 200%;
		height: 200%;
		border-bottom: 0.5px solid #ddd;
		border-radius: inherit;
		content: " ";
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		pointer-events: none;
	}

	.bg-gradual-blue {
		background-image: linear-gradient(45deg, #0081ff, #1cbbb4);
		color: #fff;
	}

	.text-blue,
	.line-blue,
	.lines-blue {
		color: #0081ff;
	}

	.bg-gradual-orange {
		background-image: linear-gradient(45deg, #ff9700, #ed1c24);
		color: #fff;
	}
</style>